import { Link } from 'react-router-dom';

/** Generic 404 for unknown routes. Styled to match the terminal theme. */
export function NotFoundPage() {
  return (
    <main id="main" className="mx-auto max-w-content px-5 py-24 text-center">
      <p className="section-kicker">{'// 404'}</p>
      <h1 className="mt-2 font-mono text-3xl font-bold tracking-tight text-fg">Page not found</h1>
      <p className="mt-3 text-muted">
        That path doesn&apos;t resolve. Let&apos;s get you back home.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 font-mono text-sm text-accent hover:underline"
      >
        <span aria-hidden>{'>'}</span> cd ~
      </Link>
    </main>
  );
}
